import { render } from "./SavedToSpendStatCard.vue?vue&type=template&id=06f6bd14&scoped=true"
import script from "./SavedToSpendStatCard.vue?vue&type=script&lang=js"
export * from "./SavedToSpendStatCard.vue?vue&type=script&lang=js"

import "./SavedToSpendStatCard.vue?vue&type=style&index=0&id=06f6bd14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f6bd14"]])

export default __exports__